export const createQuotesTickerBatch = ({ interval = 200, onFlush }) => {
  const pendingUpdates = new Map()
  let flushTimer = null

  const flush = () => {
    if (flushTimer !== null) {
      clearTimeout(flushTimer)
      flushTimer = null
    }

    if (pendingUpdates.size === 0) {
      return
    }

    const updates = [...pendingUpdates.values()]
    pendingUpdates.clear()
    onFlush(updates)
  }

  const schedule = (data) => {
    if (!data?.coinMarket) {
      return
    }

    pendingUpdates.set(data.coinMarket, data)
    if (flushTimer !== null) {
      return
    }

    flushTimer = setTimeout(flush, interval)
  }

  const cancel = () => {
    if (flushTimer !== null) {
      clearTimeout(flushTimer)
      flushTimer = null
    }
    pendingUpdates.clear()
  }

  return {
    schedule,
    flush,
    cancel,
  }
}
